import fetch from 'node-fetch';

jest.mock('../utils/deprecationLog');

global.fetch = fetch;
global.setImmediate = global.setTimeout;
